import React from 'react'
import {
  SectionCard,
  SectionTitle,
  StyledCardHeader,
  TableContainer,
} from '../../Blends.styled'
import { Table } from 'components'
import { useMediaQuery, useTheme } from '@mui/material'
import { useQuery } from 'react-query'
import { useBlendingService } from 'services'
import { blendsSavedColumns } from './columns'
import { TBlend } from '../../../../types'
import { useNavigate } from 'react-router-dom'
import { usePagination } from 'utils/hooks'

export const BlendsSavedList = () => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const { getSavedBlends } = useBlendingService()
  const navigate = useNavigate()

  const {
    currentPage: blendsSavedListCurrentPage,
    setCurrentPage: setBlendsSavedListCurrentPage,
    rowsPerPage: blendsSavedListRowsPerPage,
    setRowsPerPage: setBlendsSavedListRowsPerPage,
  } = usePagination({ tableKey: 'blendsSavedList' })

  const { data: blendsData } = useQuery({
    queryKey: [
      'blends-saved',
      blendsSavedListCurrentPage,
      blendsSavedListRowsPerPage,
    ],
    queryFn: () =>
      getSavedBlends({
        currentPage: blendsSavedListCurrentPage,
        itemsPerPage: blendsSavedListRowsPerPage,
      }),
    retry: false,
  })

  const handleViewBlendDetails = (row: TBlend) => {
    navigate(`/blends/saved/${row.id}`)
  }

  const onBlendsSavedListPaginationChange = (page: number, perPage: number) => {
    setBlendsSavedListCurrentPage(page)
    setBlendsSavedListRowsPerPage(perPage)
  }

  return (
    <SectionCard>
      <StyledCardHeader>
        <SectionTitle>Saved Blends</SectionTitle>
      </StyledCardHeader>
      <TableContainer
        sx={{
          height: isSmallScreen ? 'unset' : 'calc(100vh - 200px)',
        }}
      >
        <Table
          showHeader={true}
          showPagination={true}
          onPaginationChange={onBlendsSavedListPaginationChange}
          data={blendsData?.results}
          total={blendsData?.pagination?.total || 0}
          columns={blendsSavedColumns()}
          onRowClick={handleViewBlendDetails}
          // tableKey="blendsSavedList"
        />
      </TableContainer>
    </SectionCard>
  )
}
